import { render } from "./CopyRight.vue?vue&type=template&id=7e5a3ed5&ts=true"
import script from "./CopyRight.vue?vue&type=script&lang=ts"
export * from "./CopyRight.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__